import { Component, ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-assegnazione-presenze',
  templateUrl: './assegnazione-presenze.component.html',
  styleUrls: ['./assegnazione-presenze.component.css']
})
export class AssegnazionePresenzeComponent {
    window:any=<any>window;
    notification:any = new this.window.HPNotification();

    // funzione ausiliaria per l'autocomplete
    getFormattedAddress = (place) => {
        //@params: place - Google Autocomplete place object
        //@returns: location_obj - An address object in human readable format
        let location_obj = {
            formatted_address: ""
        };
        for (let i in place.address_components) {
            let item = place.address_components[i];

            location_obj.formatted_address = place.formatted_address;
            if (item['types'].indexOf("locality") > -1) {
                location_obj['locality'] = item['long_name']
            } else if (item['types'].indexOf("administrative_area_level_1") > -1) {
                location_obj['admin_area_l1'] = item['short_name']
            } else if (item['types'].indexOf("street_number") > -1) {
                location_obj['street_number'] = item['short_name']
            } else if (item['types'].indexOf("route") > -1) {
                location_obj['route'] = item['long_name']
            } else if (item['types'].indexOf("country") > -1) {
                location_obj['country'] = item['long_name']
            } else if (item['types'].indexOf("postal_code") > -1) {
                location_obj['postal_code'] = item['short_name']
            }

        }
        return location_obj;
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    getMinutesFromTime = (time:any="") => (+time.substring(0,2) * 60) + (+time.substring(3, 5));
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    updateView:any = () => {
        this.zone.run(() => {
            if(!this.queryparams()['assegnazione-presenze-view']) this.router.navigate([`/assegnazioni`], { queryParams: this.changeQueryParam({ "assegnazione-presenze-view" : "riepilogo" }) });
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAssegnazioneModal', element: this.elementref.nativeElement }});
                this.initModel();
            }
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['assegnazione'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#deleteAssegnazioneModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['assegnazione'] && !!this.window.usher.isLogged()) {
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAssegnazioneModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['assegnazione'] && !!this.window.usher.isLogged()) {
                this.setTempModel();
                this.window.flowup.signal.emit({name: 'close-modal', detail: { selector: '#deleteAssegnazioneModal', element: this.elementref.nativeElement }});
                this.window.flowup.signal.emit({name: 'open-modal', detail: { selector: '#assegnazioneModal', element: this.elementref.nativeElement }});
                this.setDatepickers();
            }

            this.cd.detectChanges();
        });
    };

    filter:any = {
        text: ''
    };
    temp_indirizzo:any = {};
    temp_data:any = {};
    temp:any = {cliente: '', indirizzo: '', sede: '', dipendente: ''};
    model_assegnazione:any = {
        name: this.window.appInfo.public_token_parent,
        configuration: {
            owner: this.window.appInfo.public_token_parent,
            cliente: {
                public_token: "",              // public_token del cliente
                nome: ""
            },
            dipendente: {
                public_token: "",
                nome: ""
            },                                 // public_token del dipendente
            sede: "",                          // indirizzo human-readable della sede presso la quale operare
            calendar: [],                      // obj specificato sopra
            esclusione: [],
            geolocation_requested: false,
            archived: false,
            everyone: false,                    // Flag che mi permette di scegliere se quest'assegnazione sarà applicata a tutti gli utenti
            group: "",                           // ID del gruppo a cui assegnare questa assegnazione
            show_calendar: true
        },
        geometry: {
            type: "Point",
            coordinates: [0, 0]                 // array contenente la coppia di valori latitudine e longitudine [41.909986, 12.3959159]
        }
    };
    datepickers:any = {};
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private elementref: ElementRef,
        private zone: NgZone
    ) {}

    ngAfterViewInit() {
        this.route.queryParams.subscribe((p:any) => this.updateView());
        this.window.geoBucket.element.addEventListener('change', this.updateView.bind(this));
        this.window.usher.element.addEventListener('change', this.updateView.bind(this));

        this.window.__mapsAuxObj.loadedPromise.then(() => {
            let input = this.window.document.querySelector("#indirizzo_assegnazione_autocomplete"),
                autocompleteIndirizzoAssegnazione = new this.window.google.maps.places.Autocomplete(input);
            this.window.google.maps.event.addListener(autocompleteIndirizzoAssegnazione, 'place_changed', () => {
                this.getAssegnazione().configuration.sede = this.getFormattedAddress(autocompleteIndirizzoAssegnazione.getPlace()).formatted_address;
                this.getAssegnazione().geometry.coordinates = [autocompleteIndirizzoAssegnazione.getPlace().geometry.location.lat(), autocompleteIndirizzoAssegnazione.getPlace().geometry.location.lng()];
                this.cd.detectChanges();
            });
        });
    };

    ngOnDestroy() {
        this.window.geoBucket.element.removeEventListener('change', this.updateView.bind(this));
        this.window.usher.element.removeEventListener('change', this.updateView.bind(this));
    };

    handleModal = (assegnazione:any = undefined, type:any = undefined) => {
        this.router.navigate([`/assegnazioni`], { queryParams: this.changeQueryParam({ "assegnazione" : assegnazione, "type" : type }) });
    };

    initModel = () => {
        this.model_assegnazione = {
            name: this.window.appInfo.public_token_parent,
            configuration: {
                owner: this.window.appInfo.public_token_parent,
                cliente: {
                    public_token: "",              // public_token del cliente
                    nome: ""
                },
                dipendente: {
                    public_token: "",
                    nome: ""
                },                                 // public_token del dipendente
                sede: "",                          // indirizzo human-readable della sede presso la quale operare
                calendar: [],                      // obj specificato sopra
                esclusione: [],
                geolocation_requested: false,
                archived: false,
                everyone: false,                    // Flag che mi permette di scegliere se quest'assegnazione sarà applicata a tutti gli utenti
                group: "",                           // ID del gruppo a cui assegnare questa assegnazione
                show_calendar: true
            },
            geometry: {
                type: "Point",
                coordinates: [0, 0]                 // array contenente la coppia di valori latitudine e longitudine [41.909986, 12.3959159]
            }
        };
        this.temp_data = {};
        this.temp = {cliente: '', indirizzo: '', sede: '', dipendente: ''};
        let indirizzo_autocomplete = this.window.document.querySelector("#indirizzo_assegnazione_autocomplete");
        if(!!indirizzo_autocomplete) indirizzo_autocomplete.value = "";
    };

    setTempModel = () => {
        let indirizzi = this.window.usher.getChildren(this.getAssegnazione()?.configuration?.cliente?.public_token)?.public_configuration?.indirizzo || [];
        this.temp.cliente = this.getAssegnazione().configuration.cliente.public_token;
        this.temp.dipendente = this.getAssegnazione().configuration.dipendente.public_token;
        this.temp.sede = this.getAssegnazione().configuration.sede;
        this.temp.indirizzo = indirizzi?.find(e => this.compareCoordinates(e.coordinates))?.id;
    };

    setDatepickers = () => {
        this.datepickers = {};
        for(const current of this.getAssegnazione().configuration.calendar) {
            this.datepickers[current.id] = {};
            this.datepickers[current.id].data = new this.window.HPDatepicker({
                parent: this.elementref.nativeElement,
                type: "date",
                callback: (date) => {
                    current.data_inizio = (new Date(date)).getTime();
                }
            });
            this.datepickers[current.id].ora_inizio = new this.window.HPDatepicker({
                parent: this.elementref.nativeElement,
                type: "time",
                callback: (time) => {
                    current.ora_inizio = this.getMinutesFromTime(time);
                }
            });
            this.datepickers[current.id].ora_fine = new this.window.HPDatepicker({
                parent: this.elementref.nativeElement,
                type: "time",
                callback: (time) => {
                    current.ora_fine = this.getMinutesFromTime(time);
                }
            });
        }
    };

    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };

    get = (obj:any = false) => this.window.geoBucket.getBuckets()[this.window.appInfo.buckets.geoBucket.assegnazione]?.objects?.filter(assegnazione => ((this.queryparams()['assegnazione-presenze-view'] != 'archivio' && !assegnazione.configuration.archived) || (this.queryparams()['assegnazione-presenze-view'] == 'archivio' && !!assegnazione.configuration.archived)))
        .filter(assegnazione => !this.filter.text  
        || assegnazione?.configuration?.cliente?.nome?.toLowerCase()?.includes((this.filter.text || "")?.toLowerCase())
        || assegnazione?.configuration?.sede?.toLowerCase()?.includes((this.filter.text || "")?.toLowerCase())
        || assegnazione?.configuration?.dipendente?.nome?.toLowerCase()?.includes((this.filter.text || "")?.toLowerCase()))
        .filter(assegnazione => {
        if (!obj) return true;
        if (!!obj?.param) return assegnazione.public_token == obj.param;
        switch (obj?.type) {
            case "cliente" : 
                return assegnazione?.configuration?.cliente?.public_token == obj.param;
            case "dipendente" : 
                return assegnazione?.configuration?.dipendente?.public_token == obj.param;
            case "sede" : 
                return assegnazione?.configuration?.sede?.toUpperCase().includes(obj.param.toUpperCase());
            case "admin" :
                return false;
        };
    }) || [];

    getSingleAssegnazione = (pt:any) => this.window.geoBucket.getBuckets()[this.window.appInfo.buckets.geoBucket.assegnazione]?.objects?.find(e => e.public_token == pt) || {configuration:{}};

    getAssegnazione = () => {
        if(!!this.queryparams()['assegnazione'] && this.queryparams()['assegnazione'] != 'new') return this.get({ param: this.queryparams()['assegnazione'] })[0] || this.model_assegnazione;
        return this.model_assegnazione;
    };

    getIndirizzi = () => this.window.usher.getChildren(this.getAssegnazione()?.configuration?.cliente?.public_token)?.public_configuration?.indirizzo || [];

    getClienti = (pt:any) => this.window.usher.getChildren().filter(e => e?.public_configuration?.type == 'cliente' && (!pt || e.public_token == pt));

    getDipendenti = (pt:any) => this.window.usher.getChildren().filter(e => e?.public_configuration?.type == 'dipendente' && (!pt || e.public_token == pt));

    updateModel = (ev:any, type:any = undefined) => {
        if(type == 'group') {
            let id = ev.target?.value || "";
            if(!id) return;
            this.getAssegnazione().configuration.dipendente = {
                public_token: "",
                nome: ""
            };
            this.getAssegnazione().configuration.everyone = false;
            this.getAssegnazione().configuration.group = id;
            return;
        }
        if(type == 'everyone') {
            this.getAssegnazione().configuration.dipendente = {
                public_token: "",
                nome: ""
            };
            this.getAssegnazione().configuration.group = '';
            return;
        }
        //console.log(ev);
        let cliente = !!this.temp.cliente ? this.window.usher.getChildren(this.temp?.cliente) : undefined,
            dipendente = !!this.temp.dipendente ? this.window.usher.getChildren(this.temp?.dipendente) : undefined,
            indirizzo = cliente?.public_configuration?.indirizzo?.find(el => el.id == this.temp?.indirizzo) || {},
            sede = indirizzo?.formatted_address || '';
        if(!!cliente) {
            this.getAssegnazione().configuration.cliente = {
                public_token : cliente?.public_token,
                nome : cliente?.public_configuration?.nome
            };
            this.getAssegnazione().geometry = {
                type: "Point",
                coordinates: indirizzo?.coordinates || [0, 0]
            };
            this.getAssegnazione().configuration.sede = sede;
        }
        if(!!dipendente) {
            this.getAssegnazione().configuration.everyone = false;
            this.getAssegnazione().configuration.group = "";
            this.getAssegnazione().configuration.dipendente = {
                public_token : dipendente?.public_token,
                nome : dipendente?.public_configuration?.nome
            };
        }
        /*
        this.getAssegnazione().geometry.coordinates = this.temp_indirizzo.coordinates;
        this.getAssegnazione().configuration.sede = this.temp_indirizzo.formatted_address;
        */
        return;
    };

    formatoGiorno = (index) => {
        this.setDatepickers();
        if(this.getAssegnazione().configuration.calendar[index].frequenza == "una-tantum") return this.getAssegnazione().configuration.calendar[index].giorno = new Date();
        this.getAssegnazione().configuration.calendar[index].giorno = "1";
        if(this.getAssegnazione().configuration.calendar[index].frequenza == "quindicinale") return this.getAssegnazione().configuration.calendar[index].settimana = "0";
        if(this.getAssegnazione().configuration.calendar[index].frequenza == "mensile") return this.getAssegnazione().configuration.calendar[index].settimana = "1";
    };

    newCalendarItem = () => {
        this.getAssegnazione().configuration.calendar.push({
            id: this.rand(),                        // codice univoco generato da rand()    
            data_inizio: "",//new Date(), 
            ora_inizio: this.getMinutesFromTime(this.window.moment().format("HH:mm")),
            ora_fine: this.getMinutesFromTime(this.window.moment().format("HH:mm"))+1,
            giorno: "1",
            frequenza: "settimanale"                 // una-tantum, settimanale, quindicinale, mensile
        });
        this.setDatepickers();
    };

    check = () => {
        //if (!this.getAssegnazione()?.configuration?.cliente?.public_token) return this.notification.danger({ text: 'Selezionare un cliente!' });
        if (!this.getAssegnazione()?.configuration?.calendar?.length) return this.notification.danger({ text: 'Definisci un calendario di presenza!' });
        if (!!this.getAssegnazione()?.configuration?.cliente?.public_token && !this.getAssegnazione()?.configuration?.sede && !!this.getAssegnazione()?.configuration?.geolocation_requested) return this.notification.danger({ text: 'Per richiedere la geolocalizzazione della timbrata devi inserire una sede.' });
        if (!this.getAssegnazione()?.configuration?.dipendente?.public_token && !this.getAssegnazione()?.configuration?.everyone) return this.notification.danger({ text: 'Selezionare un dipendente!' });
        return true;
    };

    handleAssegnazione = async () => {
        if(!this.check()) return;
        try {
            if(!this.getAssegnazione().configuration.cliente.public_token || !this.getAssegnazione().configuration.cliente.nome) this.getAssegnazione().configuration.cliente = {nome: this.window.usher.getPublicConfiguration().nome, public_token: this.window.usher.getPublicToken()};
            if(this.queryparams()['type'] == 'create') {
                await this.window.geoBucket.getBuckets()[this.window.appInfo.buckets.geoBucket.assegnazione]?.addObject(this.getAssegnazione());
            } else await this.getAssegnazione()?.update();
            this.handleModal(undefined, undefined);
            return this.notification.success({ text: `Assegnazione ${this.queryparams()['type'] == 'create' ? 'aggiunta' : 'aggiornata'} correttamente.` });
        } catch(e) {
            console.log(e);
            return this.notification.danger({ text: 'Errore. Riprova più tardi.' });
        }
    };

    deleteAssegnazione = async () => {
        let assegnazione = this.getAssegnazione();
        if(!this.getAssegnazione().public_token || this.queryparams()['type'] != 'delete') return;
        try {
            assegnazione.configuration.archived = true;
            await assegnazione.update();
            this.notification.success({ text: 'Assegnazione archiviata correttamente.' });
            this.handleModal(undefined, undefined);
        } catch(e) {
            console.log(e);
            this.notification.danger({ text: 'Errore. Riprova più tardi.' });
        }
        return;
    };

    recoverAssegnazione = async () => {
        let assegnazione = this.getAssegnazione();
        if(!this.getAssegnazione().public_token || this.queryparams()['type'] == 'create') return;
        try {
            //await assegnazione.delete();
            assegnazione.configuration.archived = false;
            await assegnazione.update();
            this.handleModal(undefined, undefined);
            this.notification.success({ text: 'Assegnazione ripristinata correttamente.' });
        } catch(e) {
            console.log(e);
            this.notification.danger({ text: 'Errore. Riprova più tardi.' });
        }
        return;
    };

    checkSelected = (pt:any) => {
        return this.getAssegnazione().configuration.cliente.public_token == pt || this.getAssegnazione().configuration.dipendente.public_token == pt;
    };
    
    compareCoordinates = (coords:any) => this.getAssegnazione().geometry.coordinates[0] == coords[0] && this.getAssegnazione().geometry.coordinates[1] == coords[1];
    
    getCurrent = () => {
        if(this.queryparams()['assegnazione-calendar']) return this.window.moment(+this.queryparams()['assegnazione-calendar']);
        return this.window.moment().set({hour:12,minute:0,second:0,millisecond:0});
    };

    getMonth = () => this.window.moment(this.getCurrent()).format('MMMM YYYY');
    
    prevMonth = () => {
        let current = this.getCurrent().add(-1, 'month');
        return this.router.navigate([`/assegnazioni`], { queryParams: this.changeQueryParam({ "assegnazione-calendar" : current.valueOf() }) });
    };

    nextMonth = () => {
        let current = this.getCurrent().add(1, 'month');
        return this.router.navigate([`/assegnazioni`], { queryParams: this.changeQueryParam({ "assegnazione-calendar" : current.valueOf() }) });
    };

    weekOfMonth = (data) => [1,2,3,4,5][0 | this.window.moment(data).date() / 7];
    
    weekOfYear = (data) => this.window.moment(data).weeks();

    getAssegnazioniGiornaliere = (day = 1) => this.get()
        .filter(assign => { 
            if (!assign || !assign.configuration || !assign.configuration.calendar) return false;
            return assign.configuration.calendar.find(obj_calendar => 
            (obj_calendar.frequenza == 'una-tantum' && this.window.moment(day).isSame(obj_calendar.giorno, 'day')) ||
            (obj_calendar.frequenza == 'settimanale' && obj_calendar.giorno == this.window.moment(day).day()) ||
            (obj_calendar.frequenza == 'quindicinale' && obj_calendar.giorno == this.window.moment(day).day() && (this.weekOfYear(day)%2) == obj_calendar.settimana) ||
            (obj_calendar.frequenza == 'mensile' && obj_calendar.giorno == this.window.moment(day).day() && this.weekOfMonth(day) == obj_calendar.settimana)
            );
    });

    getCurrentMonth = () => {
        let current = this.getCurrent(),
        startOfMonth = this.window.moment(current).startOf('month'),
        endOfMonth = this.window.moment(current).endOf('month'),
        day = startOfMonth,
        startDay = this.window.moment(current).startOf('month').day(),
        days = [],
        index = this.window.moment(current).startOf('month').day()-1,
        endDay = 7 - this.window.moment(current).endOf('month').day();
        
        days[0] = [];

        if(startDay < 1) startDay = 7;
        if(index<0) index = 6;

        while(startDay > 1) {
            days[0].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            startDay -= 1;
        };

        while (day <= endOfMonth) {
            let weekIndex = Math.floor(index/7);
            days[weekIndex] = days[weekIndex] || [];
            days[weekIndex].push({
                day : day,
                number : day.format('DD'),
                selected : this.window.moment(current).isSame(day, 'day'),
                free : !this.getAssegnazioniGiornaliere(day).length
            });
            day = day.clone().add(1, 'd');
            index += 1;
        };

        while(days[days.length-1].length < 7){
            days[days.length-1].push({
                day : "",
                number : "",
                disabled: true,
                selected : false
            });
            endDay -= 1;
        };

        return days;
    };

    setCurrentDay = (day:any = {}) => {
        let current = this.window.moment(day);
        return this.router.navigate([`/assegnazioni`], { queryParams: this.changeQueryParam({ "assegnazione-calendar" : current.valueOf() }) });
    };

    isCurrent = (day) => this.window.moment(day).isSame(this.window.moment(), 'day');

    getCellClass = (day) => {
        let classList = [];
        if(this.isCurrent(day.day)) classList.push('current-day');
        if(day.selected) classList.push('selected-day');
        if(!day.free && !!day.number) classList.push('event');
        if(!day.number) classList.push('prev-month');
        return classList.join(" ");
    };

    getCurrentAssegnazioni = (day_obj:any = null, array_assegnazioni:any = null) => {
        let assegnazioni = array_assegnazioni || this.get(),
            day = day_obj || this.getCurrent(),
            result = [];
        for(let i=0; i<assegnazioni.length; i++) {
            let current_assegnazione = assegnazioni[i];
            for(let j=0; j<current_assegnazione.configuration.calendar.length; j++) {
                let current_calendar = current_assegnazione.configuration.calendar[j];

                if((current_calendar.frequenza == "una-tantum" && this.window.moment(current_calendar.data_inizio).isSame(day, 'day')) || 
                    (current_calendar.frequenza == "settimanale" && current_calendar.giorno == day.day()) || 
                    (current_calendar.frequenza == 'quindicinale' && current_calendar.giorno == day.day() && (this.weekOfYear(day)%2) == current_calendar.settimana) || 
                    (current_calendar.frequenza == 'mensile' && current_calendar.giorno == this.window.moment(day).day() && this.weekOfMonth(day) == current_calendar.settimana)) {
                    result.push({
                        public_token_assegnazione: current_assegnazione.public_token,
                        id_calendar: current_calendar.id
                    });
                }
            }
        }
        return result;
    };
}